import { render, staticRenderFns } from "./JSelectGrade.vue?vue&type=template&id=9ddc1f14&scoped=true"
import script from "./JSelectGrade.vue?vue&type=script&lang=js"
export * from "./JSelectGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddc1f14",
  null
  
)

export default component.exports